// tslint:disable-next-line:eofline
export * from './creationNouvelle.component';
